<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">      
      <v-container grid-list-xl fluid>        
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <v-card pa-0>   
              <v-toolbar flat dense cad>
                <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
                  <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
                  ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
                </v-chip>
                <v-toolbar-title class="subheading" :class="fm.kompetisi.color+'--text'" :style="'color:'+fm.kompetisi.color">Surat Suara {{fm.kompetisi.name}}</v-toolbar-title>
                <v-spacer></v-spacer>                                                                               
                <v-menu bottom left>
                  <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                  <v-list>           
                    <v-list-tile v-bind:to="{path:'/analisis/', query:$route.query}">
                      <v-list-tile-title>Index</v-list-tile-title>
                    </v-list-tile> 
                    <v-list-tile v-bind:to="{path:'/analisis/form', query:$route.query}">
                      <v-list-tile-title>Update</v-list-tile-title>
                    </v-list-tile>                                        
                  </v-list>                  
                </v-menu>
              </v-toolbar>
              <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>    
              <v-card-text class="pa-0">                
                <v-layout row wrap class="mt-1">
                  <v-flex lg6 md6 sm12 xs12>
                    <v-list-tile>
                      <v-list-tile-action><v-icon color="cyan">room</v-icon></v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{fm.tps.name}}</v-list-tile-title>
                        <v-list-tile-sub-title>location : {{fm.tps.alamat}}</v-list-tile-sub-title>
                      </v-list-tile-content>                          
                    </v-list-tile>                    
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12 >
                    <v-list-tile v-if="fm.dapil">
                      <v-list-tile-action><v-icon color="cyan">language</v-icon></v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{fm.dapil.name}}</v-list-tile-title>
                        <v-list-tile-sub-title>dapil</v-list-tile-sub-title>
                      </v-list-tile-content>                          
                    </v-list-tile>                    
                  </v-flex>                                    
                </v-layout>
                <v-alert :value="$validator.errors.items.length==0 ? false : true" type="warning">                       
                  <ul>
                    <li v-for="(item) in $validator.errors.items">{{item.msg}}</li>
                  </ul>
                </v-alert>
                <v-expansion-panel
                  v-model="panel" flat class="elevation-0 ma-0"
                  expand
                >
                  <v-expansion-panel-content v-bind:key="1" class="grey lighten-4">
                    <div slot="header" >I. Data Jumlah Suara Per Calon</div>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>                                            
                          <v-flex lg4 sm6 xs12 v-for="(calon, i) in fm.calons">              
                            <v-card>
                              <v-toolbar :color="calon.color" dark>
                                <v-toolbar-title class="white--text display-2">0{{calon.no}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <span class="headline">{{quickcountMode?calon.quickcount:calon.suara }}</span>                                
                              </v-toolbar>
                              <v-img
                                v-bind:src="calon.img?calon.img:require('@/assets/img/avatar/blank-eks.jpg')"
                                aspect-ratio="1.95"
                                >                                                
                              </v-img>
                              <v-card-text class="pa-0">
                                <v-container class="pa-0">                          
                                  <v-divider></v-divider>                          
                                  <v-flex lg12 class="align-center text-sm-center">{{calon.name}}</v-flex>
                                  <v-divider></v-divider>
                                  <v-flex lg12>
                                    <v-avatar size="30" class="ma-1" v-for="(partai, i) in calon.partai"  :color="partai.color">            
                                      <img :src="partai.thumb" v-if="partai.thumb"/>
                                      <span v-else class="white--text headline"></span>
                                    </v-avatar>
                                  </v-flex>                          
                                </v-container>                         
                              </v-card-text>
                            </v-card>                                
                          </v-flex> 
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="2" class="grey lighten-5">
                    <div slot="header" >II. Data Jumlah Suara Sah dan Tidak Sah</div>
                    <v-card>
                      <v-card-text>
                        <div class="v-table__overflow tabular">
                          <table class="v-datatable v-table theme--light">
                            <thead>
                              <tr><th role="columnheader">No.</th>
                                <th>Uraian</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>Jumlah suara sah seluruh calon</td>
                                <td>{{fm.sah}}</td>
                              </tr>
                              <tr>
                                <td>2</td>
                                <td>Jumlah suara <strong>tidak</strong> sah</td>
                                <td>{{fm.tdk_sah?fm.tdk_sah:'-'}}</td>
                              </tr>
                              <tr>
                                <td>3</td>
                                <td>Jumlah suara sah dan tidak sah (1+2)</td>
                                <td>{{parseInt(fm.sah) + parseInt(fm.tdk_sah)}}</td>
                              </tr>
                            </tbody>
                          </table>  
                        </div>  
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>                  
                  <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="3" class="grey lighten-4">
                    <div slot="header" >III. Data Penggunaan Surat Suara</div>
                    <v-card>
                      <v-card-text>
                        <div class="v-table__overflow tabular">
                          <table class="v-datatable v-table theme--light">
                            <thead>
                              <tr><th role="columnheader">No.</th>
                                <th>Uraian</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>Jumlah surat suara yang digunakan</td>
                                <td>{{fm.digunakan=(parseInt(fm.sah) + parseInt(fm.tdk_sah))}}</td>
                              </tr>
                              <tr>
                                <td>2</td>
                                <td>Jumlah surat suara yang <strong>tidak</strong> digunakan</td>
                                <td>{{fm.tdk_digunakan?fm.tdk_digunakan:'-'}}</td>
                              </tr>
                              <tr>
                                <td>3</td>
                                <td>Jumlah surat suara yang dikembalikan pemilih karena rusak</td>
                                <td>{{fm.rusak?fm.rusak:'-'}}</td>
                              </tr>
                              <tr>
                                <td>4</td>
                                <td>Jumlah surat suara yang diterima termasuk cadangan 2% (1+2+3)</td>
                                <td>{{parseInt(fm.digunakan)+parseInt(fm.tdk_digunakan)+parseInt(fm.rusak)}}</td>
                              </tr>
                            </tbody>
                          </table>  
                        </div>  
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="4" class="grey lighten-5">
                    <div slot="header" >IV. Data Pemilih dan Penggunaan Hak Pilih</div>
                    <v-card>
                      <v-card-text>
                        <div class="v-table__overflow tabular">
                          <table class="v-datatable v-table theme--light">
                            <thead>
                              <tr><th role="columnheader">Bag.</th>
                                <th>No.</th>
                                <th>Uraian</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            
                            <tbody>
                              <tr>
                                <td>A</td>                                
                                <td colspan="2"><strong>DATA PEMILIH</strong></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>1</td>
                                <td>Pemilih terdaftar dalam Daftar Pemilih Tetap (DPT)</td>
                                <td>{{fm.dpt=parseInt(fm.tps.pt_l)+parseInt(fm.tps.pt_p)}}</td>
                              </tr>                              
                              <tr>
                                <td></td>
                                <td>2</td>
                                <td>Pemilih dari Daftar Pemilih Tambahan (DPTb)</td>
                                <td>{{fm.dptb?fm.dptb:'-'}}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>3</td>
                                <td>Pemilih terdaftar dalam Daftar Pemilih Khusus (DPK)</td>
                                <td>{{fm.dpph?fm.dpph:'-'}}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>4</td>
                                <td>Jumlah Pemilih (1+2+3)</td>
                                <td>{{(parseInt(fm.dpt)+parseInt(fm.dpph)+parseInt(fm.dptb))}}</td>
                              </tr>
                              <tr>
                                <td>B</td>                                
                                <td colspan="2"><strong>PENGGUNA HAK PILIH</strong></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>1</td>
                                <td>Penggunaan hak pilih dalam Daftar Pemilih Tetap (DPT)</td>
                                <td>{{fm.pen_dpt?fm.pen_dpt:'-'}}</td>
                              </tr>                              
                              <tr>
                                <td></td>
                                <td>2</td>
                                <td>Penggunaan hak pilih dalam Daftar Pemilih Tambahan (DPTb)</td>
                                <td>{{fm.pen_dptb?fm.pen_dptb:'-'}}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>3</td>
                                <td>Penggunaan hak pilih dalam Daftar Pemilih Khusus (DPK)</td>
                                <td>{{fm.pen_dpph?fm.pen_dpph:'-'}}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>4</td>
                                <td>Jumlah seluruh pengguna hak pilih (1+2+3)</td>
                                <td>{{parseInt(fm.pen_dpt)+parseInt(fm.pen_dpph)+parseInt(fm.pen_dptb)}}</td>
                              </tr>
                            </tbody>
                          </table>  
                        </div>  
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-if="!quickcountMode" v-bind:key="5" class="grey lighten-4">
                    <div slot="header" >V. Foto Form C1 Plano</div>
                    <v-card>
                      <v-card-text>
                        <viewer :images="images">
                          <img v-for="src in images" :src="src" :key="src" style="max-width:200px; width:50%;">
                        </viewer>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>  
                </v-expansion-panel>                                   
              </v-card-text>
            </v-card>  
          </v-flex>
        </v-layout>
      </v-container>            
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Hitung';    
import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer/src/component.vue"

var model = new Model();

export default {    
    components: {      
      Viewer
    },
    $_veeValidate: {
        validator: 'new'
    },           
    data: () => ({     
        panel: [true,true,true,true,true],
        loading : false,
        quickcountMode : false,
        images: [],
        fm :{
          kompetisi : {color:'white', name:null},
          tps : {name:null, alamat: null},
          dapil : {name:null},
          calons : [],
          
          kompetisi_id:null,
          tps_id:null,
          
          sah : null,
          tdk_sah : null,
          
          digunakan: null,
          tdk_digunakan: null,
          rusak : null,
          
          dpt_l : null,
          dpt_p : null,
          
          dpt  : null,
          dpph : null,
          dptb : null,
          
          pen_dpt  : null,
          pen_dpph : null,
          pen_dptb : null,
        }
        
    }),
    watch:{        
    },
    created () { 
        
    },    
    mounted () {this.init();}, 
    methods : {        
      
        init(){                        
            this.$validator.localize('en', this.dictionary);  
            this.loading = true;
            this.fm.kompetisi_id = this.$route.query.kompetisi_id;
            this.fm.tps_id       = this.$route.query.tps_id;
            return model.surat({kompetisi_id:this.fm.kompetisi_id, tps_id:this.fm.tps_id}).then(res=>{
              if(res.status === 200){
                  Object.assign(this.fm, res.data);  
                  this.watching();
                  this.setImages();
              }
              this.loading = false;         
            });
        },
        
        watching(){          
          this.fm.calons.forEach((calon,i)=>{
            this.$watch(['fm','calons',i,'suara'].join('.'), (suara)=>{if(suara!==null){
              this.setSah();
            }});                        
          });
          this.setSah();
        },
        
        setSah(){
          this.fm.sah = 0;
          this.fm.calons.forEach((cal)=>{
            this.fm.sah += cal.suara ? parseInt(cal.suara):0;             
          });
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.fm.time = this.$moment().valueOf();
            this.fm.info = null;
            if( !this.errors.any() ) { this.loading = true;
                var res = isUpdate ? await model.update(this.fm): await model.create(this.fm);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                } this.loading = false;
            }             
        },
               
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                            
        clear () {
            this.fm = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.name.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },   
        
        setImages(){
            this.images = []
            model.getC1Download({kompetisi_id:this.fm.kompetisi_id,tps_id:this.fm.tps_id}).then(res=>{
                this.images = res.data;
            });
        }
    }
}
</script>